import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef } from 'react';
import { useTheme } from 'styled-components';
import * as Styled from './WaveformCanvas.styles';
import { drawWaveform, setCanvasDimensions } from './WaveformCanvas.utils';
var WaveformCanvas = function WaveformCanvas(_ref) {
  var waveformData = _ref.waveformData,
    clipped = _ref.clipped;
  var canvasRef = useRef(null);
  var theme = useTheme();
  var updateCanvasAndDraw = useCallback(function () {
    var canvas = canvasRef.current;
    if (!canvas || !waveformData) {
      return;
    }

    // Set up canvas for proper rendering on all displays
    setCanvasDimensions(canvas);

    // Draw the waveforms with CSS variables
    drawWaveform(canvas, waveformData, clipped ? theme.colors.brandPrimary : theme.colors.textDisabled);
  }, [waveformData, theme, clipped]);

  // Initialize and handle resize events
  useEffect(function () {
    if (!waveformData || !canvasRef.current) {
      return undefined;
    }

    // Initial draw
    updateCanvasAndDraw();

    // Create resize observer
    var resizeObserver = new ResizeObserver(function () {
      updateCanvasAndDraw();
    });

    // Start observing the canvas parent element
    resizeObserver.observe(canvasRef.current.parentElement);

    // Cleanup: disconnect observer when component unmounts
    return function () {
      resizeObserver.disconnect();
    };
  }, [waveformData]); // Only depend on waveform data

  return /*#__PURE__*/React.createElement(Styled.Wrapper, null, /*#__PURE__*/React.createElement("canvas", {
    ref: canvasRef
  }));
};
WaveformCanvas.propTypes = {
  clipped: PropTypes.bool,
  waveformData: PropTypes.arrayOf(PropTypes.number)
};
WaveformCanvas.defaultProps = {
  clipped: false,
  waveformData: []
};
export default /*#__PURE__*/React.memo(WaveformCanvas);